import { useState } from 'react';

const FloatingButtons = () => {
  const [whatsappHover, setWhatsappHover] = useState(false);
  const [phoneHover, setPhoneHover] = useState(false);

  return (
    <div className="fixed bottom-6 right-6 z-40 flex flex-col space-y-3">
      {/* WhatsApp Button */}
      <a
        href="https://wa.me/905514803007?text=Merhaba%2C%20karsiyakavisaconsulting.com.tr%20web%20siteniz%20%C3%BCzerinden%20yaz%C4%B1yorum."
        target="_blank"
        rel="noopener noreferrer"
        onMouseEnter={() => setWhatsappHover(true)}
        onMouseLeave={() => setWhatsappHover(false)}
        className="group relative flex items-center cursor-pointer"
      >
        <div
          className={`absolute right-14 bg-green-600 text-white px-4 py-2 rounded-lg text-sm font-medium shadow-lg transition-all duration-300 whitespace-nowrap ${
            whatsappHover ? 'opacity-100 translate-x-0' : 'opacity-0 translate-x-4 pointer-events-none'
          }`}
        >
          WhatsApp'tan Yaz
        </div>
        <div className="w-14 h-14 bg-green-600 rounded-full flex items-center justify-center text-white shadow-lg hover:scale-110 transition-transform cursor-pointer">
          <i className="ri-whatsapp-fill text-2xl"></i>
        </div>
      </a>

      {/* Phone Button */}
      <a
        href="tel:+905514803007"
        onMouseEnter={() => setPhoneHover(true)}
        onMouseLeave={() => setPhoneHover(false)}
        className="group relative flex items-center cursor-pointer"
      >
        <div
          className={`absolute right-14 bg-navy-900 text-white px-4 py-2 rounded-lg text-sm font-medium shadow-lg transition-all duration-300 whitespace-nowrap ${
            phoneHover ? 'opacity-100 translate-x-0' : 'opacity-0 translate-x-4 pointer-events-none'
          }`}
        >
          Hemen Ara
        </div>
        <div className="w-14 h-14 bg-navy-900 rounded-full flex items-center justify-center text-white shadow-lg hover:scale-110 transition-transform cursor-pointer">
          <i className="ri-phone-fill text-2xl"></i>
        </div>
      </a>
    </div>
  );
};

export default FloatingButtons;
